export default __webpack_public_path__ + "static/media/P308.1.5d1e47c9.mp3";